import React, { useState } from 'react'
import { Box, Typography, Tabs, Tab } from '@mui/material'
import UserBalance from '../UserBalance/UserBalance'
import UserStatus from '../UserStatus/UserStatus'
import UserLastActivity from '../UserLastActivity/UserLastActivity'
import DeliveryList from '../DeliveryList/DeliveryList'
import PaymentHistory from '../PaymentHistory/PaymentHistory'

const UserDashboard = () => {
  const [selectedTab, setSelectedTab] = useState(0) // Управление текущей вкладкой

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue) // Переключение вкладок
  }

  return (
    <Box sx={{ p: 2, maxWidth: 800, margin: 'auto' }}>
      <Typography variant="h4" gutterBottom>
        Личный кабинет пользователя
      </Typography>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        textColor="primary"
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        sx={{ marginBottom: 3 }}
      >
        <Tab label="Информация" />
        <Tab label="Список адресов" />
        <Tab label="История оплат" />
      </Tabs>

      {/* Содержимое вкладок с прокруткой внутри вкладки */}
      <Box>
        {selectedTab === 0 && (
          <Box
            sx={{
              height: '400px', // Высота области с контентом на мобильных устройствах
              overflowY: 'auto', // Прокрутка включена только для содержимого вкладки
              padding: 2,
            }}
          >
            <UserBalance />
            <UserStatus />
            <UserLastActivity />
          </Box>
        )}
        {selectedTab === 1 && (
          <Box
            sx={{
              padding: 2,
            }}
          >
            <DeliveryList />
          </Box>
        )}
        {selectedTab === 2 && (
          <Box
            sx={{
              height: '400px',
              overflowY: 'auto',
              padding: 2,
            }}
          >
            <PaymentHistory />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default UserDashboard
